module.exports = __webpack_public_path__ + "img/man_2_3.7d325ce6.png";